const combineStrings = (list, seperator = ' ', lastSeperator) => {
  const $list = _.isArray(list) ? list : [list]
  return _.compact($list).join(seperator).trim()
}

export default combineStrings
